"use strict";

(function () {
	if (typeof xxzpawvbpvwnwawbnazvkkpqvbhwadva !== "object"
		|| typeof xxzpawvbpvwnwawbnazvkkpqvbhwadva.strings !== "object")
	{
		return;
	}

	const strings = xxzpawvbpvwnwawbnazvkkpqvbhwadva.strings;

	strings.language = "English";
	strings.comma = ".";
	strings.thousands_seperator = ",";
	strings.decimal = ".";
	strings.select = "Select";
	strings.unselect = "Deselect";
	strings.calculate = "Finish and calculate";

	strings.units.metric = "Metric";
	strings.units.imperial = "Imperial";
	strings.units.long = {
		l: "litres",
		ml: "millilitres",
		m: "metres",
		cm: "centimetres",
		mm: "millimetres",
		f: "feet",
		in: "inches",
		sqare_m: "square metres",
		sqare_cm: "square centimetres",
		sqare_f: "square feet",
		sqare_in: "square inches"
	};

	strings.steps = {
		remove: { label: "Remove", intro: "", extro: "" },
		wash: { label: "Clean", intro: "", extro: "" },
		grind: { label: "Sand", intro: "", extro: "" },
		prime: { label: "Prime", intro: "", extro: "" },
		apply: { label: "Apply", intro: "", extro: "" }
	};

	strings.product_kinds.by_ID = {
		Antifouling: "Antifouling",
		Primer: "Primer",
		Old_Antifouling: "Existing antifouling"
	};
	strings.product_categories.by_ID = {
		Standard: "Standard",
		Premium: "Premium",
		No_Biocide: "Biocide-free",
		No_Biocide_Premium: "Biocide-free premium"
	};

	strings.questions = {
		go_to_previous: "Previous question",
		go_to_next: "Next question",
		need_to_asnwer_all: "Please answer all required questions first.",
		invalid_measurements: "Please enter valid values greater than zero for waterline length, waterline beam and draft.",
		q1: {
			label: "What is the current condition of the antifouling?",
			text: "The condition determines whether the existing coating can be overcoated or needs to be removed.",
			number: "1"
		},
		q2: {
			label: "What is the hull material?",
			text: "The hull material determines which antifouling products and primers are suitable.",
			number: "2"
		},
		q3: {
			label: "Where is the boat mainly used?",
			text: "The water type and local fouling pressure influence the required protection.",
			number: "3"
		},
		q4: {
			label: "How fast is the boat?",
			text: "Higher speeds require a more abrasion-resistant coating.",
			number: "4"
		},
		q5: {
			label: "How often is the boat used?",
			text: "Boats that move less often generally need stronger fouling protection.",
			number: "5"
		},
		q6: {
			label: "What type and dimensions does the boat have?",
			text: "Enter the waterline length, the maximum beam at the waterline and the draft from the water surface to the lowest point.",
			number: "6"
		},
		q7: {
			label: "Are there any special conditions to consider?",
			text: "Select every condition that applies. If none apply, continue without selecting an option.",
			number: "7"
		}
	};

	strings.answers = {
		q1a1: { label: "No existing antifouling", text: "No antifouling has been applied yet." },
		q1a2: { label: "Poor condition", text: "The existing coating has cracks, flaking or loose areas." },
		q1a3: { label: "Unknown but intact", text: "The existing coating is intact, but the product is unknown." },
		q1a4: { label: "Known and intact", text: "Select the existing antifouling so that compatibility can be checked." },
		q2a1: { label: "GRP", text: "Glass-reinforced plastic / fibreglass" },
		q2a2: { label: "Wood", text: "" },
		q2a3: { label: "Steel", text: "" },
		q2a4: { label: "Aluminium", text: "" },
		q3a1: { label: "Salt water", text: "" },
		q3a2: { label: "Fresh water", text: "" },
		q3a3: { label: "Brackish water", text: "" },
		q4a1: { label: "Up to 40 knots", text: "Approximately 74 km/h" },
		q4a2: { label: "Up to 70 knots", text: "Approximately 130 km/h" },
		q5a1: { label: "Daily", text: "" },
		q5a2: { label: "Weekly", text: "" },
		q5a3: { label: "Monthly or less", text: "" },
		q6a1: { label: "Waterline length", text: "Measure from bow to stern along the waterline." },
		q6a2: { label: "Waterline beam", text: "Enter the widest beam at the waterline." },
		q6a3: { label: "Draft", text: "Measure vertically from the water surface to the lowest point of the keel or hull." },
		q6a4: {
			label: "Boat type",
			text: "",
			selection: {
				Motorboot: "Motorboat",
				Kurzkieler: "Fin-keel yacht",
				Langkieler: "Full-keel yacht",
				Kurzkieler_Katamaran: "Fin-keel catamaran",
				Langkieler_Katamaran: "Full-keel catamaran"
			}
		},
		q7a1: { label: "Boat is based in the Netherlands", text: "" },
		q7a2: { label: "Very heavy fouling in the cruising area", text: "" },
		q7a3: { label: "Boat remains in the water all year", text: "" },
		q7a4: { label: "Tropical waters or the Mediterranean", text: "" },
		q7a5: { label: "Drying, muddy berth", text: "" },
		q7a6: { label: "The coating must be biocide-free", text: "" },
		q7a7: { label: "The boat is trailer-sailed", text: "" },
		q7a8: { label: "Self-polishing antifouling is prohibited in the marina", text: "" }
	};

	strings.boat = {
		label: "Boat",
		name: "Boat name",
		length: { label: "Length", info: "Waterline length" },
		width: { label: "Beam", info: "Maximum beam at the waterline" },
		depth: { label: "Draft", info: "Draft from the water surface" },
		material: { label: "Material", info: "" },
		area: { label: "Underwater area", info: "Calculated underwater area in square metres" },
		types: {
			Motorboot: "Motorboat",
			Kurzkieler: "Fin-keel yacht",
			Langkieler: "Full-keel yacht",
			Kurzkieler_Katamaran: "Fin-keel catamaran",
			Langkieler_Katamaran: "Full-keel catamaran"
		}
	};

	strings.start = {
		label: "Antifouling configurator",
		intro: "Find the right underwater coating for your boat in seven clear steps.",
		text1: "You will receive a product and primer recommendation matched to your answers.",
		text2: "The result includes the calculated quantity, suitable pack sizes and application guidance.",
		text3: "No personal information is required.",
		text4: "",
		text5: "",
		begin: "Start configurator",
		resume: "Continue previous session",
		extro: "Please contact us if you need help with your result."
	};

	strings.recipe = {
		label: "Your coating plan",
		intro: "",
		boat: { label: "Boat" },
		recommendation: { label: "[[product]]", no_product_label: "No suitable recommendation" },
		no_product: {
			label: "No suitable recommendation",
			text: "The selected requirements cannot be covered reliably by the current range. Please contact us so that we can check the coating system with you."
		},
		product: {
			label: "[[product]]",
			text: "For a calculated underwater area of [[area_m]] m&sup2;, we recommend [[recommended]]. The calculated requirement is [[volume_text]] for [[layers_text]]. The cart quantity below is rounded up to available pack sizes.",
			unique_selling_points: { label: "Why [[product]] fits:", text: "" },
			colour_selection: { label: "Colour", text: "" }
		},
		alternatives: {
			label: "Alternatives",
			standard: "Standard",
			premium: "Premium option",
			no_biocide: "Biocide-free option",
			no_biocide_premium: "Biocide-free premium option"
		},
		steps: { label: "Application steps" },
		extro: { label: "", text: "" },
		order: {
			label: "Quantities and cart",
			text: "The calculated quantities are rounded up to available pack sizes.",
			total: "Total",
			button: "Add antifouling to cart",
			primer: { text: "Add [[primer]] to cart", button: "Add [[primer]] to cart" },
			both: { text: "Add antifouling and primer to cart", button: "Add both to cart" },
			button_all: "Add all products to cart",
			progress: "Adding products to cart...",
			success: "All products were added to the cart.",
			failure: "The products could not be added to the cart. Please try again."
		}
	};
})();
